import 'regenerator-runtime/runtime';
import 'core-js/stable';

import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import createBrowserApolloClient from '@sm/apollo-clients/dist/browser';

import { clientErrorHandler } from '@sm/webassets';
import possibleTypes from './helpers/possibleTypes';
import { bootstrapSMWeb, createApp, getLocaleMessages, mount } from './utils';

const { staticData, environ, locale } = bootstrapSMWeb(window);
const {
  pageRequestId,
  'client-config': { appName, appVersion, graphQLUri },
  gql: { gqlCache = {} } = {},
} = staticData;

const apolloClient: ApolloClient<NormalizedCacheObject> = createBrowserApolloClient({
  uri: graphQLUri,
  cacheHydration: gqlCache,
  pageRequestId,
  possibleTypes,
  linkOptions: {
    credentials: 'include',
    batchInterval: 30,
  },
  metadata: { appName, appVersion },
  availableLoggedOutPaths: ['/lo-graphql/teamJoin'],
});

getLocaleMessages(locale)
  .then(createApp(environ, staticData, apolloClient))
  .then(mount(document))
  .catch(clientErrorHandler.logError);
